import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How far in advance should I book a ride?",
      answer: "We recommend booking at least 24-48 hours in advance to ensure availability. For same-day requests, please call our dispatch at (360) 482-3996 and we'll do our best to accommodate you based on availability."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept private pay (cash, credit cards, and debit cards) for direct bookings. All insurance and Medicaid transportation is handled through approved brokers who coordinate the rides and handle all insurance verification and billing. We do not directly work with insurance companies or check insurance cards."
    },
    {
      question: "Do you accept Medicaid/insurance?",
      answer: "All insurance-related transportation, including Medicaid, is coordinated through approved brokers. We work with multiple Medicaid brokers and insurance brokers throughout Washington State. Your broker handles all insurance verification and coordinates the transportation with us. We do not directly accept insurance or check insurance cards."
    },
    {
      question: "What should I bring for my ride?",
      answer: "You don't need to bring ID or insurance cards. Just bring contact information for your destination and any necessary medical documentation. If you have mobility aids, please let us know in advance so we can ensure the appropriate vehicle is dispatched."
    },
    {
      question: "What is your cancellation policy?",
      answer: "We understand that circumstances change. Please notify us as soon as possible if you need to cancel or reschedule. Cancellations should be made at least 2 hours in advance when possible. Repeated no-shows or last-minute cancellations may result in additional fees."
    },
    {
      question: "What areas do you serve?",
      answer: "We serve all 39 counties in Washington State, covering both Western and Eastern Washington. From Aberdeen to Spokane, from Bellingham to Vancouver, we provide transportation services throughout the entire state. We serve cities and communities across all regions of Washington."
    },
    {
      question: "Do you provide wheelchair accessible vehicles?",
      answer: "Yes, we have a fleet of ADA-compliant wheelchair accessible vehicles. Our trained drivers are experienced in wheelchair securement and assistance. Please specify your mobility needs when booking so we can dispatch the appropriate vehicle."
    },
    {
      question: "Can family members ride along?",
      answer: "Yes, family members or caregivers can ride along. Please let us know when booking if you'll have additional passengers so we can ensure adequate seating. There may be additional charges for extra passengers depending on the service type."
    },
    {
      question: "What if I need to make changes to my booking?",
      answer: "You can make changes to your booking by calling our dispatch at (360) 482-3996. Please call as soon as possible to make changes, especially for same-day modifications. We'll do our best to accommodate changes based on availability."
    },
    {
      question: "Do you provide service on weekends and holidays?",
      answer: "Yes, we provide service seven days a week, including holidays. However, availability may be limited on holidays, so we recommend booking well in advance for holiday transportation needs."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq" id="faq">
      <div className="container">
        <motion.div
          className="faq-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Frequently Asked Questions</h2>
          <p>Have questions? We're here to help. Find answers to common questions about our transportation services.</p>
        </motion.div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <motion.div
              className="faq-item"
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              viewport={{ once: true }}
            >
              <button
                className={`faq-question ${openIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <FaChevronDown 
                  className={`faq-icon ${openIndex === index ? 'rotated' : ''}`}
                />
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    className="faq-answer"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="faq-cta"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p>Still have questions?</p>
          <a href="#contact" className="cta-link">Contact Us</a>
          <span> or call us at </span>
          <a href="tel:3604823996" className="cta-link">(360) 482-3996</a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;

